<nb-card size="medium">
    <nb-card-header>{{summaryView?.title}}</nb-card-header>
    <nb-list>
        <nb-list-item *ngFor="let viewField of viewFields">
            <div class="viewField">
                <span>{{viewField?.title}}</span>
                <span>{{viewField?.value}}</span>
            </div>
        </nb-list-item>
    </nb-list>
</nb-card>
